import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';

/**
 * Flô's first-use legal disclaimer (Aviso de Isenção de Responsabilidade). Opened once per user by
 * {@link FloOverlayService} before the chat panel attaches; the acknowledgment is logged server-side.
 * Required — opened with `disableClose`, so the only way forward is the ciência checkbox + "Continuar".
 */
@Component({
	selector: 'app-flo-disclaimer-dialog',
	standalone: true,
	imports: [MatDialogModule, MatButtonModule, MatCheckboxModule],
	changeDetection: ChangeDetectionStrategy.OnPush,
	templateUrl: './flo-disclaimer-dialog.component.html',
	styleUrls: ['./flo-disclaimer-dialog.component.scss']
})
export class FloDisclaimerDialogComponent {
	readonly acknowledged = signal(false);

	constructor(private dialogRef: MatDialogRef<FloDisclaimerDialogComponent>) {}

	accept(): void {
		if (!this.acknowledged()) return;
		this.dialogRef.close(true);
	}
}
